export default "__VITE_ASSET__DsX_7GPM__"